import React from "react";

const forecastFields = [
  { field: "alt1", className: "navlog-input alt1-col" },
  { field: "wd1", className: "navlog-input alt1-col" },
  { field: "ws1", className: "navlog-input alt1-col" },
  { field: "t1", className: "navlog-input alt1-col" },

  { field: "alt2", className: "navlog-input alt2-col" },
  { field: "wd2", className: "navlog-input alt2-col" },
  { field: "ws2", className: "navlog-input alt2-col" },
  { field: "t2", className: "navlog-input alt2-col" },

  { field: "alt3", className: "navlog-input alt3-col" },
  { field: "wd3", className: "navlog-input alt3-col" },
  { field: "ws3", className: "navlog-input alt3-col" },
  { field: "t3", className: "navlog-input alt3-col" },
];

function ForecastTable({
  forecastTerminals,
  stationList = [],
  updateForecastTerminalCell,
  altitudes,
}) {
  return (
    <div className="navlog-wrapper">
      <table
        style={{
          width: "100%",
          tableLayout: "fixed",
          marginTop: "12px",
          fontSize: "18px",
   
        }}
      >
        <thead>
          <tr>
            <th className="navlog-blank" style={{fontSize: "10px"}}></th>
            <th className="navlog-th alt1-col" colSpan="4">Altitude1</th>
            <th className="navlog-th alt2-col" colSpan="4">Altitude2</th>
            <th className="navlog-th alt3-col" colSpan="4">Altitude3</th>

          </tr>
          <tr>
            <th id = "navlog-th" style={{fontSize: "24px"}}>FT</th>

            <th className="navlog-th alt1-col">Alt</th>
            <th className="navlog-th alt1-col">Dir</th>
            <th className="navlog-th alt1-col">Kts</th>
            <th className="navlog-th alt1-col">°C</th>

            <th className="navlog-th alt2-col">Alt</th>
            <th className="navlog-th alt2-col">Dir</th>
            <th className="navlog-th alt2-col">Kts</th>
            <th className="navlog-th alt2-col">°C</th>

            <th className="navlog-th alt3-col">Alt</th>
            <th className="navlog-th alt3-col">Dir</th>
            <th className="navlog-th alt3-col">Kts</th>
            <th className="navlog-th alt3-col">°C</th>
          </tr>
        </thead>

        <tbody>
          {forecastTerminals.map((ftRow, i) => (
            <tr key={i}>

              {/* FT Station Selector */}
              <td>
                <select
                  className="navlog-input"
                  value={ftRow.ft}
                  onChange={(e) =>
                    updateForecastTerminalCell(
                      i,
                      "ft",
                      e.target.value.toUpperCase()
                    )
                  }
                >
                  {stationList.map((code) => (
                    <option key={code} value={code}>
                      {code}
                    </option>
                  ))}
                </select>
              </td>

              {/* Forecast Data Cells */}
              {forecastFields.map(({ field, className }) => {
                return (
                <td key={field} className={className}>
                  <span className="forecast-value">
                    {field === "alt1"
                      ? altitudes.alt1
                      : field === "alt2"
                      ? altitudes.alt2
                      : field === "alt3"
                      ? altitudes.alt3
                      : ftRow[field] ?? ""}
                  </span>
                </td>
              );
              })}
             </tr> 
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ForecastTable;